import { AuthService } from "src/app/shared/services/auth_service";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavigationEnd, Router } from "@angular/router";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { NavController, Platform } from "@ionic/angular";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { FCM } from "plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM";
import { BackgroundMode } from "@ionic-native/background-mode/ngx";
// session timeout
// import { IdleSessionTimeout } from "idle-session-timeout";
import { Deeplinks } from "@ionic-native/deeplinks/ngx";
import { BnNgIdleService } from "bn-ng-idle";
import { LoggerService } from "./shared/services/logger.service";
import { AboutusPage } from "./aboutus/aboutus.page";
import { DashboardpagePage } from "./dashboardpage/dashboardpage.page";
import { SplashScreen } from "@awesome-cordova-plugins/splash-screen/ngx";
import { LobbypagePage } from "./lobbypage/lobbypage.page";
import { ContestDetailPage } from "./contest-listing/contest-detail/contest-detail.page";
import { PickemCricketPageModule } from "./games/pickem-lobbypage/pickem-cricket/pickem-cricket.module";
import { PickemCricketPage } from "./games/pickem-lobbypage/pickem-cricket/pickem-cricket.page";
import { PickemLobbypagePage } from "./games/pickem-lobbypage/pickem-lobbypage.page";
import { SignupPage } from "./signuppage/signuppage.page";

type CurrentPlatform = "browser" | "native";
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit {
  // @ViewChild(Nav) navChild:Nav;
  // routerhidden = true;
  @ViewChild("splash", { static: false }) splash: ElementRef;
  public appPages = [
    { title: "Home", url: "/lobbypage", icon: "home" },
    { title: "How To Play", url: "/how-to-play", icon: "heart" },
    { title: "Profile", url: "/profile", icon: "heart" },
    { title: "About Us", url: "/aboutus", icon: "archive" },
    { title: "FAQ's", url: "/faq", icon: "trash" },
    { title: "Contact US", url: "/contactus", icon: "mail" },
    { title: "Logout", icon: "warning", url: "/signup" },
  ];
  userName: string;
  email: string;
  isLogin: boolean = false;
  fcmToken: string;
  notification_id: any = "";
  isWeb = false;
  isMobileWeb = false;
  // session = new IdleSessionTimeout(5 * 60 * 1000);
  public env = environment;
  private _currentPlatform: CurrentPlatform;
  showInstallCard: boolean;
  isMacOs: boolean | null;
  isWindowsOs: boolean | null;
  isCancel: string = localStorage.getItem("isCancelInstall");

  constructor(
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private appVersion: AppVersion,
    private platform: Platform,
    private fcm: FCM,
    private httpClient: HttpClient,
    private BackgroundMode: BackgroundMode,
    private navController: NavController,
    private bnIdle: BnNgIdleService,
    private logger: LoggerService,
    private deeplinks: Deeplinks,
    private splashScreen: SplashScreen
  ) {
    this.showInstallCard = true;
    this.isWindowsOs = false;
    this.isMacOs = false;
    this.platform.ready().then(() => {
      this.isWeb = this.platform.is("desktop") || this.platform.is("mobileweb");
      this.isMobileWeb = this.platform.is("mobileweb");
      localStorage.setItem("isWeb", String(this.isWeb));
      localStorage.setItem("isCancelInstall", "false");
      localStorage.setItem("isMobileWeb", String(this.isMobileWeb));
      if (
        this.platform.is("ios") ||
        (this.platform.is("android") &&
          !(this.platform.is("desktop") || this.platform.is("mobileweb")))
      ) {
        this._currentPlatform = "native";
        localStorage.setItem("isNative", "true");
      } else {
        this._currentPlatform = "browser";
        localStorage.setItem("isNative", "false");
      }
      this.getLocalStorageItems();

      this.splashScreen.hide();
      // setTimeout(()=>{
      //   this.routerhidden = false;
      // },10000);
      if (!this.isWeb) {
        this.getfcmToken();
        this.fcmNotification();
        this.fcm.onTokenRefresh().subscribe((data) => {
          // this.logger.log({ exception: 'app.component:this.fcm.onTokenRefresh', data }).subscribe(d => console.log(d));
        });
      }
    });
  }

  ngOnInit() {
    console.log("Spalshscreen-2");
    console.log('%c Test Deep Link','color:blue',new Date());
    this.platform.ready().then(() => {
      this.deepLinks();
      this.appVersion.getVersionNumber().then(
        (res) => {
          console.log(res);
          localStorage.setItem("app_version", "V." + res);
        },
        (err) => {
          console.log(err);
        }
      );
    });

    const lang = localStorage.getItem("language");
    if (lang) {
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
    } else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      localStorage.setItem("language", "en");
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (localStorage.getItem("token")) {
          this.isLogin = true;
          this.userName = localStorage.getItem("user_name");
          this.email = localStorage.getItem("user_email");
        } else {
          this.isLogin = false;
        }
      }
    });

    //deepLinking
    // this.deepLinks('init2');
    console.log("deeplinks");

    this.bnIdle.startWatching(1814400).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        console.log("session expired");
        console.log("You are loggedout");
        this.logout();
      }
    });
  }

  ngAfterViewInit() {
    // this.deepLinks('afterView');
  }

  cancelInstall() {
    this.showInstallCard = false;
    localStorage.setItem("isCancelInstall", "true");
  }

  getLocalStorageItems() {
    localStorage.setItem("isWeb", String(this.isWeb));
    localStorage.setItem("isCancelInstall", "false");
    localStorage.setItem("isMobileWeb", String(this.isMobileWeb));
    const isWeb = localStorage.getItem("isWeb");
    const isCancelInstall = localStorage.getItem("isCancelInstall");
    const isMobileWeb = localStorage.getItem("isMobileWeb");
    const isNative = localStorage.getItem("isNative");
    this.isMacOs = window.navigator.userAgent.toLowerCase().includes("mac");
    this.isWindowsOs =
      window.navigator.userAgent.toLowerCase().includes("windows") ||
      window.navigator.userAgent.toLowerCase().includes("android");
    if (
      (isWeb === "true" || isMobileWeb === "true" || isNative === "false") &&
      isCancelInstall === "false"
    ) {
      this.showInstallCard = true;
    } else {
      this.showInstallCard = false;
    }
  }

  deepLinks() {
    // This is the code who responds to the app deeplinks
    // Deeplinks if from Ionic Native
    this.deeplinks
      .route({
        "/signup": SignupPage,
        "/aboutus": AboutusPage,
        "/lobbypage": LobbypagePage,
        "/contest-listing": LobbypagePage,
        "/contest-detail": ContestDetailPage,
        "/contest-detail/:matchId": ContestDetailPage,
        "/contest-detail/:matchId/:contestId": ContestDetailPage,
        "/games/pickem-lobbypage/:matchId/:fromTeam": PickemLobbypagePage,
      })
      .subscribe(
        (match) => {
          console.log("match0001++++++=>" + match);
          if (match.$link.path.includes("signup")) {
            this.router.navigate(["/signup"]);
          } else if (match.$link.path.includes("aboutus")) {
            console.log('match-->1');
            this.router.navigate(["/aboutus"]);
          } else if (match.$link.path.includes("contest-detail")) {
            console.log('match-->2');
            this.router.navigate(["/contest-detail"], {
              queryParams: {
                isFromDeepLink: true,
                deepLinkMatchId: match.$args.matchId,
                deepLinkContestId: match.$args.contestId,
              },
            });
          } else if (match.$link.path.includes("games/pickem-lobbypage")) {
            console.log('match-->3');
            this.router.navigate(["/games"], {
              queryParams: {
                isFromDeepLink: true,
                deepLinkMatchId: match.$args.matchId,
                fromTeam: match.$args.fromTeam,
              },
            });
          }
          // match.$route - the route we matched, which is the matched entry from the arguments to route()
          // match.$args - the args passed in the link
          // match.$link - the full link data
          console.log("Successfully matched route1", match);
        }, (nomatch) => {
          // nomatch.$link - the full link data
          console.error("NO match---------->", nomatch);
        } 
      );
    // this.deeplinks.routeWithNavController(this.navController, {
    //   '/aboutus': AboutusPage,
    //   '/dashboardpage': DashboardpagePage,
    //   '/lobbypage': LobbypagePage,
    //   // '/items/:itemId': ItemDetailsPage
    // }).subscribe((match) => {
    //   alert('match2++++++=>'+match);
    //   console.log('Successfully routed2', match);
    // }, (nomatch) => {
    //   console.log('Unmatched Route2', nomatch);
    //   alert('nomatch2----=>'+nomatch);
    // });

    // this.deeplinks.route({
    //   '/about-us': AboutusPage,
    //   '/dashboardpage': DashboardpagePage,
    // }).subscribe(match => {
    //   // match.$route - the route we matched, which is the matched entry from the arguments to route()
    //   // match.$args - the args passed in the link
    //   // match.$link - the full link data
    //   console.log('Successfully matched route', match);
    // }, nomatch => {
    //   // nomatch.$link - the full link data
    //   console.error('Got a deeplink that didn\'t match', nomatch);
    // });
    // this.deeplinks.routeWithNavController(this.navController, {
    //   '/about-us': AboutusPage,
    // }).subscribe(match => {
    //   // match.$route - the route we matched, which is the matched entry from the arguments to route()
    //   // match.$args - the args passed in the link
    //   // match.$link - the full link data
    //   console.log('Successfully matched route', match);
    // }, nomatch => {
    //   // nomatch.$link - the full link data
    //   console.error('Got a deeplink that didn\'t match', nomatch);
    // });
  }

  // backgroundprocess() {
  //   console.log("backGroundProcess started");
  //   document.addEventListener('deviceready', () => {
  //     this.BackgroundMode.enable();
  //     this.BackgroundMode.setDefaults(
  //       {
  //         title: 'executing in bg mode...',
  //         text: 'background mode was activated successfully!',
  //         color: '#fff',
  //         resume: true,
  //         silent: false
  //       }
  //     );
  //     this.BackgroundMode.disableWebViewOptimizations();
  //     this.BackgroundMode.on('activate').subscribe(() => {
  //       setTimeout(() => {
  //         this.testFunction();
  //       }, 3000);
  //     });
  //   });
  // }

  testFunction() {
    try {
      let body = {
        notification: {
          body: "Team work makes the Dream work!!  invite your friends to Namma11 now and earn Rs 500 as bonus money",
          notification_id: "15",
          title: "Sharing is Caring, especially when it pays",
          url: "https://namma11mas.intuceo.com/r/6a47485b890ff0fdc694300f5?ct=YTozOntzOjEyOiJub3RpZmljYXRpb24iO2k6MTU7czo0OiJsZWFkIjtzOjM6IjMzNyI7czo3OiJjaGFubmVsIjthOjE6e3M6MTI6Im5vdGlmaWNhdGlvbiI7aToxNTt9fQ%3D%3D&",
          wasTapped: false,
        },
        data: {},
        to: "faUxiH6XSuOlYcylSdYKVo:APA91bFllBgXOEWCpuwF4PBNs7jRJ5sLhURS_ZOpMIRUXFEEB3-xg-Cc2bx3HzhtN8wTob1rpTS25BTFokkjr_mEB1quRLD_GoFMWPgv7O4_erwDo1M6XAVjCmsGB4nsTR_TsZYROs_B",
        priority: "high",
        restricted_package_name: "",
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization:
          "key=AAAAN4dmF-8:APA91bHH_fu-zUxzximQODKmwR2syxLlfblRos5yCUvZb_1HptyTzdXITAIbvBu3YmXbEFuE4pGuVcqxD-xgBtU9h9DzSPlD1A9cTUnFyC8wMbzcHEQlIAFzxMLEKkLEvTMB_MlwJs9m",
      };
      console.log(body);
      console.log(headers);
      this.httpClient
        .post("https://fcm.googleapis.com/fcm/send", JSON.stringify(body), {
          headers: headers,
        })
        .subscribe((data) => {
          console.log(data);
          //this.notification_id = body.notification.notification_id;
        });
    } catch (e) {
      console.log(e);
    }
  }

  fcmNotification() {
    try {
      this.fcm.onNotification().subscribe((data) => {
        console.log(data);
        let email = localStorage.getItem("user_email");
        // this.logger.log({ exception: 'app.component:OnNotification', data: { data, token: this.fcmToken, email, platforms: this.platform.platforms() } }).subscribe(d => console.log(d));
        let body = {
          notification: data,
          data: {},
          to: this.fcmToken,
          priority: "high",
          restricted_package_name: "",
        };
        const headers = {
          "Content-Type": "application/json",
          Authorization:
            "key=AAAAN4dmF-8:APA91bHH_fu-zUxzximQODKmwR2syxLlfblRos5yCUvZb_1HptyTzdXITAIbvBu3YmXbEFuE4pGuVcqxD-xgBtU9h9DzSPlD1A9cTUnFyC8wMbzcHEQlIAFzxMLEKkLEvTMB_MlwJs9m",
        };
        console.log(body);
        console.log(headers);
        // if (body.notification.notification_id !== this.notification_id) {
        this.httpClient
          .post("https://fcm.googleapis.com/fcm/send", JSON.stringify(body), {
            headers: headers,
          })
          .subscribe((data) => {
            console.log(data);
            // this.logger.log({ exception: 'app.component:fcm/send:if', data: { data, body, notification_id: this.notification_id } }).subscribe(d => console.log(d));
            this.notification_id = body.notification.notification_id;
          });
        // } else {
        //   this.logger.log({ exception: 'app.component:fcm/send:else', data: { data, body, notification_id: this.notification_id } }).subscribe(d => console.log(d));
        // }
        if (data.wasTapped) {
          console.log("Received in background");
        } else {
          console.log("Received in foreground");
        }
      });
      console.log("subscribe");
    } catch (e) {
      console.log(e);
      // this.logger.log({ exception: 'app.component:OnNotification:error', data: { error: e.message || e.msg || e, errorJSON: JSON.stringify(e, null, 4) } }).subscribe(d => console.log(d));
    }
  }

  async getfcmToken() {
    try {
      this.fcm
        .getToken()
        .then((token) => {
          this.fcmToken = token;
          let email = localStorage.getItem("user_email");
          console.log(email);
          let body = {
            email: email,
            push_id: this.fcmToken,
            enabled: true,
          };
          const headers = new HttpHeaders();
          headers.append("Content-Type", "application/json");
          console.log(body);
          // this.logger.log({ exception: 'app.component:getToken:then1', data: { token, email, platforms: this.platform.platforms() } }).subscribe(d => console.log(d));
          this.httpClient
            .post(`${this.env.appcallback}/notification/appcallback`, body, {
              headers: headers,
            })
            .subscribe((data) => {
              console.log(data);
              // this.logger.log({ exception: 'app.component:notification/appcallback', data: { data, body } }).subscribe(d => console.log(d));
            });
          localStorage.setItem("fcm_token=>", this.fcmToken);
        })
        .catch((error) => {
          // this.logger.log({ exception: 'app.component:getToken:catch', data: { error: error.message || error.msg || error, errorJSON: JSON.stringify(error, null, 4) } }).subscribe(d => console.log(d));
          console.log(error);
        });
    } catch (e) {
      console.log(e);
      // this.logger.log({ exception: 'app.component:getfcmToken:catch', data: { error: e.message || e.msg || e, errorJSON: JSON.stringify(e, null, 4) } }).subscribe(d => console.log(d));
    }
  }

  // session.onTimeOut = () => {
  //   // here you can call your server to log out the user
  //       console.log("timeOut");
  // }
  logout() {
    console.log("User logged out!");
    this.authService.logout();
  }
}
